import { createContext, useContext, useEffect, useState } from "react";
import api, { API } from "@/lib/api";
import queryClient from "@/lib/queryClient";

const AuthContext = createContext(null);

/** Aquece a API em background (Container Cloudflare). */
function warmApi() {
  try {
    fetch(`${API}/health`, { method: "GET", mode: "cors", credentials: "include", cache: "no-store" }).catch(() => {});
  } catch {
    /* ignore */
  }
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    warmApi();
    api
      .get("/auth/me")
      .then((r) => {
        setUser(r.data);
        import("@/lib/prefetch").then(({ prefetchPage }) => {
          prefetchPage("/");
          prefetchPage("/agendamentos");
          prefetchPage("/clientes");
          prefetchPage("/financeiro");
        });
      })
      .catch(() => setUser(false))
      .finally(() => setReady(true));
  }, []);

  const login = async (email, password) => {
    warmApi();
    const { data } = await api.post("/auth/login", { email, password });
    queryClient.clear();
    setUser(data.user);
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {
      /* sessão já expirada */
    }
    queryClient.clear();
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
